import {AddressType} from 'desktop/types/addressType';
import {capitalize} from 'libs/utils/utils';

import {ADDRESSES} from '../../store/sagas/deliveryStep/deliveryStepRootSaga/constants';

export type AddressForFormType = AddressType & {
    type: string;
    region: string;
    regionID: string;
    isAddressesSame: boolean;
    customerId: string;
};

type PreparedAddressType = {
    firstname: string;
    lastname: string;
    street: string;
    city: string;
    telephone: string;
    postcode: string;
    region?: string;
    regionId?: number;
    countryCode: string;
    customer: {
        id: string;
    };
    defaultShipping?: boolean;
    defaultBilling?: boolean;
};

/**
 * Prepare address data for request to backend
 * @param {AddressType} address - Received address to modification to form data object
 * @returns {PreparedAddressType} Prepared address object
 */
export const createAddressForForm = (address: AddressForFormType): PreparedAddressType => ({
    city: address.city.value,
    firstname: address.firstName.value,
    lastname: address.lastName.value,
    postcode: address.postal.value,
    region: address.region,
    street: `${address.address.value}\n${address.other.value}`,
    telephone: address.phone.value,
    ...(address.regionID ? {regionId: Number(address.regionID)} : {}),
    [`default${capitalize(address.type)}`]: true,
    [`default${capitalize(ADDRESSES[address.type].oppositeValue)}`]: address.isAddressesSame,
    countryCode: address.country.value,
    customer: {
        id: address.customerId,
    },
});
